import React from 'react';
import remove from 'lodash.remove';
import { forceCheck } from 'react-lazyload';
import { Category } from './category';
import { Playlist, IPlaylist } from './playlist';
import { ISubscriptionState } from '../../reducers/subscription-reducers';
import { IKidsModeState } from '../../reducers/kids-mode-reducers';
import { IReduxProps } from '../../actions/action-types';
import { ICategory } from '../../reducers/category-reducers';

const prePlaylistCategoryIds: readonly string[] = ['watchlist', 'recent'];

interface ICategoriesProps extends IReduxProps {
	categories: ICategory[];
	playlists?: IPlaylist[];
	subscription: ISubscriptionState;
	kidsMode: IKidsModeState;
}

export class Categories extends React.Component<ICategoriesProps> {
	componentDidUpdate(prevProps: ICategoriesProps) {
		const { categories, playlists } = this.props;
		const { categories: prevCategories, playlists: prevPlaylists } = prevProps;
		if (prevCategories !== categories || prevPlaylists !== playlists) {
			forceCheck();
		}
	}

	render() {
		const { categories, playlists, subscription, dispatch, kidsMode } = this.props;
		const remainingCategories = [...categories];
		const prePlaylistCategories: ICategory[] = remove(remainingCategories, x => prePlaylistCategoryIds.includes(x.id));

		return (
			<div className="categories">
				{prePlaylistCategories
					? prePlaylistCategories.map(category => (
							<Category
								key={category.id}
								category={category}
								dispatch={dispatch}
								subscription={subscription}
								kidsMode={kidsMode}
							/>
					  ))
					: false}
				{playlists
					? playlists.map(playlist => (
							<Playlist key={playlist.id} playlist={playlist} dispatch={dispatch} subscription={subscription} />
					  ))
					: false}
				{remainingCategories
					? remainingCategories.map(category => (
							<Category
								key={category.id}
								category={category}
								dispatch={dispatch}
								subscription={subscription}
								kidsMode={kidsMode}
							/>
					  ))
					: false}
			</div>
		);
	}
}
